'use strict';

const getPageNameFromFragment = () => ({
    current: Odigeo.History.getPageNameFromFragment(),
});

const onGoBack = (info, callback) => () => callback(getPageNameFromFragment(), info);

const onNavigated = (info, callback) => (pageData) => callback(pageData, info);

module.exports = {
    bindEvents(info, callback = (() => {})) {
        window.addEventListener('popstate', onGoBack(info, callback));
        Odigeo.bind('Odigeo.History:navigated', onNavigated(info, callback));
    },

    bindAppearancesTrackingAtPageLoad(info, callback = (() => {})) {
        Odigeo.bind('Odigeo.History:started', (pageData) => callback(pageData, info));
    },
};
